module.exports = __webpack_public_path__ + "static/media/commonGlow.1d4999a2.png";